
export const TLCCookie = {};
TLCCookie.set = function ( name, value ) {
	return $.cookie( name, value );
};

TLCCookie.get = function ( name ) {

	return $.cookie( name );
};

TLCCookie.remove = function ( name ) {

	return $.removeCookie( name );
};